import { render, staticRenderFns } from "./HeaderList.vue?vue&type=template&id=63bf84db&scoped=true&"
import script from "./HeaderList.vue?vue&type=script&lang=js&"
export * from "./HeaderList.vue?vue&type=script&lang=js&"
import style0 from "./HeaderList.vue?vue&type=style&index=0&id=63bf84db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bf84db",
  null
  
)

export default component.exports